import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import idbKeyvalAdapter from "./1_utility";
import devDebug from "../Helpers/debug";

// define the initial state
const initialState = {
  page: 1,
  search: "",
  pageSize: 10,
  totalPages: null,
  pageInput: false,
  usersList: [],
  hideColumns: [],
};
const currentAppVersionFromEnv = Number(import.meta.env.VITE_VERSION);

export const useListUsersStore = createWithEqualityFn(
  persist(
    immer((set, get) => ({
      ...initialState,
      selectColumn: (col) =>
        set((state) => {
          if (state.hideColumns.includes(col)) {
            state.hideColumns = state.hideColumns.filter((c) => c !== col);
          } else {
            state.hideColumns = [...state.hideColumns, col];
          }
        }),
      setPage: (payload) =>
        set((state) => {
          state.page = payload;
        }),
      setSearch: (payload) =>
        set((state) => {
          state.search = payload;
        }),
      setPageSize: (payload) =>
        set((state) => {
          state.pageSize = payload;
        }),
      setTotalPages: (payload) =>
        set((state) => {
          state.totalPages = payload;
        }),
      setPageInput: (payload) =>
        set((state) => {
          state.pageInput = payload;
        }),
      setUsersList: (payload) =>
        set((state) => {
          state.usersList = payload;
        }),
      resetState: () => {
        useListUsersStore.persist.clearStorage();
        set(initialState);
      },
    })),
    {
      name: import.meta.env.VITE_LIST_USERS_STORE_KEY,
      storage: createJSONStorage(() => idbKeyvalAdapter),
      version: currentAppVersionFromEnv,
      migrate: (persistedState, storedVersion) => {
        devDebug(
          `[listUsersStore Migrate] Called! Stored: ${storedVersion} (type: ${typeof storedVersion}), App: ${currentAppVersionFromEnv} (type: ${typeof currentAppVersionFromEnv})`
        );
        if (storedVersion !== currentAppVersionFromEnv) {
          devDebug('[listUsersStore Migrate] Versions differ. Resetting to initialState.');
          return initialState;
        }
        if (persistedState === null || persistedState === undefined) {
          devDebug('[listUsersStore Migrate] Persisted state is null/undefined despite version match. Resetting.');
          return initialState;
        }
        devDebug('[listUsersStore Migrate] Versions same. Using persisted state.');
        return persistedState;
      },
      // merge: (persistedState, currentState) => {
      //   devDebug('[listUsersStore Merge] Merging state...');
      //   if (typeof persistedState !== 'object' || persistedState === null) {
      //     devDebug('[listUsersStore Merge] Persisted state is not an object, returning current state or initialState.');
      //     return initialState;
      //   }
      //   return mergeDeepLeft(persistedState, currentState);
      // },
      onRehydrateStorage: (state) => {
        devDebug(`[listUsersStore onRehydrateStorage] Attempting rehydration...`);
        return (hydratedState, error) => {
          if (error) {
            console.error(
              `[listUsersStore] Failed to rehydrate store!`,
              error
            );
            devDebug(
              `[listUsersStore] Error during rehydration. Store name: "listUsersStore".`,
              "Error object:", error,
              "State passed to onRehydrateStorage:", state, // This is the raw value from storage before parsing/migration
              "Hydrated state (if available):", hydratedState // This is the state *after* potential migration/parsing, if it got that far
            );
          } else {
            // devDebug(
            //   `[listUsersStore] Successfully rehydrated. Hydrated state:`,
            //   hydratedState
            // );
          }
        };
      },
    }
  ),
  shallow
);
